var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"meter",style:({ height: (_vm.percent + "%") })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/pablo/vortex/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e48a742","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/pablo/vortex/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!/home/pablo/vortex/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buildings/common/VerticalStorage.vue
// module id = null
// module chunks = 